var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    staticClass: "app--main",
    attrs: {
      "isMain": ""
    }
  }, [_c('main-visual'), _c('main-section-primary', {
    staticClass: "secondary lighten-5 grey--text text--darken-4",
    attrs: {
      "titWrapClass": "tit-wrap--lg"
    },
    scopedSlots: _vm._u([{
      key: "subtit",
      fn: function () {
        return [_vm._v("Product story")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$t("main.section1")))];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--lg",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('main-product-link', {
    attrs: {
      "num": "01",
      "href": "/product/zero-zang",
      "name": "제로장",
      "tag": "zeroZang.tag"
    },
    scopedSlots: _vm._u([{
      key: "txt",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('zeroZang.txt'))
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('main-product-link', {
    attrs: {
      "num": "02",
      "href": "/product/k-zang",
      "name": "케이장",
      "tag": "kZang.tag"
    },
    scopedSlots: _vm._u([{
      key: "txt",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('kZang.txt'))
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4",
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }, [_c('main-product-link', {
    attrs: {
      "num": "03",
      "href": "/product/multi-sauce",
      "name": "떡볶이의 꿈",
      "tag": "DOT.tag"
    },
    scopedSlots: _vm._u([{
      key: "txt",
      fn: function () {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('DOT.txt'))
          }
        })];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('main-section-primary', {
    staticClass: "main-section--company",
    attrs: {
      "titWrapClass": "tit-wrap--lg"
    },
    scopedSlots: _vm._u([{
      key: "subtit",
      fn: function () {
        return [_vm._v("Company")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$t("main.section2")))];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "main-section--company__bg"
  }, [_c('v-img', {
    attrs: {
      "eager": "",
      "src": "/images/main/company-banner.jpg"
    }
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--xl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-img', {
    staticClass: "main-section--company__icon",
    attrs: {
      "eager": "",
      "src": "/images/main/icon-food.png",
      "data-aos": "zoom-out",
      "data-aos-delay": "100"
    }
  }), _c('p', {
    staticClass: "main-section--company__txt",
    attrs: {
      "data-aos": "fade-down",
      "data-aos-delay": "100"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('main.story1'))
    }
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "rounded-lg",
    attrs: {
      "eager": "",
      "src": "/images/main/company-01.jpg"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "pt-60px pt-md-80px pt-lg-100px"
  }, [_c('v-row', {
    staticClass: "row--xl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "rounded-lg",
    attrs: {
      "eager": "",
      "src": "/images/main/company-02.jpg"
    }
  })], 1), _c('v-col', [_c('v-img', {
    staticClass: "main-section--company__icon",
    attrs: {
      "eager": "",
      "src": "/images/main/icon-tech.png",
      "data-aos": "zoom-out",
      "data-aos-delay": "100"
    }
  }), _c('p', {
    staticClass: "main-section--company__txt",
    attrs: {
      "data-aos": "fade-down",
      "data-aos-delay": "100"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('main.story2'))
    }
  })])], 1)], 1)], 1), _c('div', {
    staticClass: "pt-60px pt-md-80px pt-lg-100px"
  }, [_c('v-row', {
    staticClass: "row--xl",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "data-aos": "zoom-out",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "main-section--company__icon",
    attrs: {
      "eager": "",
      "src": "/images/main/icon-global.png",
      "data-aos": "zoom-out",
      "data-aos-delay": "100"
    }
  }), _c('p', {
    staticClass: "main-section--company__txt",
    attrs: {
      "data-aos": "fade-down",
      "data-aos-delay": "100"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('main.story3'))
    }
  })])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('v-img', {
    staticClass: "rounded-lg",
    attrs: {
      "eager": "",
      "src": "/images/main/company-03.jpg"
    }
  })], 1)], 1)], 1)]), _c('main-section-tertiary', {
    staticClass: "main-section--contact"
  }, [_c('div', {
    staticClass: "main-section--contact__map"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d799.0581304991767!2d127.99448926963363!3d36.764988972621595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35645fe8b999e3d9%3A0x54f5cd6872669f0b!2z7Lap7LKt67aB64-EIOq0tOyCsOq1sCDsl7Dtko3rqbQg7Zal6rWQ66Gc7ZmN66y46ri4IDc!5e0!3m2!1sko!2skr!4v1704880610936!5m2!1sko!2skr",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-row', {
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "main-section--contact__card",
    attrs: {
      "rounded": "",
      "color": "primary",
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('u-tit-subtit', {
    staticClass: "white--text"
  }, [_vm._v("Contact Us")]), _c('tit-primary', [_vm._v(_vm._s(_vm.$t("오시는 길")))]), _c('v-divider', {
    staticClass: "my-20px my-md-30px my-lg-40px",
    attrs: {
      "dark": ""
    }
  }), _c('txt-primary', {
    staticClass: "white--text"
  }, [_c('div', [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "font-weight-extrabold"
  }, [_vm._v("Address")])]), _c('v-col', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t("addressTxt")))])])], 1)], 1), _c('div', {
    staticClass: "pt-12px pt-lg-24px"
  }, [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "font-weight-extrabold"
  }, [_vm._v("Tel")])]), _c('v-col', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t("010-2345-8499")))])])], 1)], 1), _c('div', {
    staticClass: "pt-12px pt-lg-24px"
  }, [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "font-weight-extrabold"
  }, [_vm._v("E-mail")])]), _c('v-col', [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("kevin1327@naver.com")])])], 1)], 1), _c('div', {
    staticClass: "pt-12px pt-lg-24px"
  }, [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('span', {
    staticClass: "font-weight-extrabold"
  }, [_vm._v("SNS")])]), _c('v-col', [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "/",
      "icon": "",
      "x-small": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/main/icon-blog.png"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "/",
      "icon": "",
      "x-small": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/main/icon-instagram.png"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)]), _c('v-divider', {
    staticClass: "mt-20px mt-md-30px mt-lg-40px",
    attrs: {
      "dark": ""
    }
  })], 1)], 1)], 1)], 1), _c('popup-layer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }